import { FC } from "react";
import { Message, Messages } from "capitalrx-components-2.0/lib/general";
import { Stack } from "capitalrx-components-2.0/lib/layout";
import { Body, Semibold } from "capitalrx-components-2.0/lib/typography";

interface PACreateError {
  message: string;
  errorCode?: string;
  details?: Record<string, string>;
}

interface PACreateErrorDisplayProps {
  error: PACreateError;
}

const ERROR_HELP_TEXT: Record<string, string> = {
  MEMBER_NOT_FOUND: "Check that the Member ID and Date of Birth are correct.",
  INVALID_NDC: "The NDC must be 11 digits.",
  INVALID_PROVIDER: "The Provider NPI is not valid.",
  DRUG_NOT_COVERED: "This drug is not covered under the member's plan.",
  INVALID_QUESTIONNAIRE: "Complete all required clinical criteria questions.",
  DUPLICATE_CASE: "A case for this member and drug already exists.",
  PA_TOOL_NOT_MIGRATED: "This client is not configured for PA Tool.",
  EPA_CONFIG_MISSING: "Electronic PA is not configured for this client.",
  INVALID_ICD10: "One or more diagnosis codes are invalid.",
};

export const PACreateErrorDisplay: FC<PACreateErrorDisplayProps> = ({ error }) => {
  const helpText = error.errorCode ? ERROR_HELP_TEXT[error.errorCode] : null;

  return (
    <Message appearance={Messages.Error} visible testId="pa-create-error">
      <Stack spacing="small">
        <Body>
          <Semibold>{error.message}</Semibold>
        </Body>

        {helpText && (
          <Body size="small">{helpText}</Body>
        )}

        {error.details && Object.keys(error.details).length > 0 && (
          <Stack spacing="mini">
            <Body size="small"><Semibold>Additional information:</Semibold></Body>
            {Object.entries(error.details).map(([key, value]) => (
              <Body key={key} size="small">• {key}: {value}</Body>
            ))}
          </Stack>
        )}
      </Stack>
    </Message>
  );
};

export default PACreateErrorDisplay;
